(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-header"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initMfDrawer() {
    var hamburger = document.querySelector('.mf-hamburger');
    if (!hamburger) return;
    var controls = hamburger.getAttribute('aria-controls');
    if (!controls) return;
    var drawer = document.getElementById(controls);
    if (!drawer) return;
    if (drawer.dataset.mfBound === '1') return;
    drawer.dataset.mfBound = '1';

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    }

    hamburger.addEventListener('click', open);
    drawer.querySelectorAll('[data-mf-drawer-close]').forEach(function(el) {
      el.addEventListener('click', close);
    });
    drawer.querySelectorAll('[data-mf-drawer-link]').forEach(function(a) {
      a.addEventListener('click', close);
    });
    drawer.querySelectorAll('[data-mf-drawer-grouptoggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.mf-mobile-drawer-group');
        if (!group) return;
        var isOpen = group.getAttribute('aria-expanded') === 'true';
        group.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }
  function initMfNavScroll() {
    var nav = document.querySelector('.mf-nav');
    if (!nav || nav.dataset.mfScrollBound === '1') return;
    nav.dataset.mfScrollBound = '1';
    var threshold = 60;
    var ticking = false;
    function update() {
      nav.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMfDrawer();
      initMfNavScroll();
    });
  } else {
    initMfDrawer();
    initMfNavScroll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-main-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.mf-main-product').forEach(initSection);

  function initSection(s) {
    if (s.dataset.mfBound === '1') return;
    s.dataset.mfBound = '1';

    var moneyFormat = s.dataset.mfMoneyFormat || '${{amount}}';
    var atcLabels = {
      '90day':   s.dataset.mfAtcLabel90 || 'Subscribe & Get Kit FREE — Start the 90-Day',
      '30day':   s.dataset.mfAtcLabel30 || 'Subscribe — Monthly',
      'onetime': s.dataset.mfAtcLabelOne || 'Add to cart'
    };

    // Return all bundled (3-Pack prepaid) allocations sorted by delivery interval ascending.
    function allocs90(v) {
      var arr = (v && v.selling_plan_allocations) || [];
      if (!arr.length) return [];
      var bundled = arr.filter(function(a) { return a.price > a.per_delivery_price; });
      // Fallback: if nothing matches the "bundled" pattern, pick the single highest-priced.
      if (!bundled.length) {
        var fallback = arr.slice().sort(function(a, b) { return b.price - a.price; })[0];
        return fallback ? [fallback] : [];
      }
      return bundled.sort(cadenceSort);
    }
    // Return all single-delivery (1-Pack) allocations sorted by delivery interval ascending.
    function allocs30(v) {
      var arr = (v && v.selling_plan_allocations) || [];
      if (!arr.length) return [];
      var single = arr.filter(function(a) { return a.price === a.per_delivery_price; });
      if (!single.length) {
        var fallback = arr.slice().sort(function(a, b) { return a.price - b.price; })[0];
        return fallback ? [fallback] : [];
      }
      return single.sort(cadenceSort);
    }
    // Express a cadence as a unitless weight for sorting. Tries the delivery_policy first;
    // falls back to parsing the plan name (Appstle sometimes leaves delivery_policy null).
    function cadenceWeight(alloc) {
      var n = parseInt(alloc.delivery_interval_count, 10);
      var u = (alloc.delivery_interval || '').toLowerCase();
      if (!isNaN(n) && n > 0 && u) {
        if (u === 'day') return n;
        if (u === 'week') return n * 7;
        if (u === 'month') return n * 30;
        if (u === 'year') return n * 365;
      }
      // Fall back: parse "Every 4 Weeks" / "4 weeks" / etc. from the plan name.
      var name = alloc.selling_plan_name || '';
      var match = name.match(/(\d+)\s*(day|week|month|year)/i);
      if (match) {
        var num = parseInt(match[1], 10);
        var unit = match[2].toLowerCase();
        if (unit === 'day') return num;
        if (unit === 'week') return num * 7;
        if (unit === 'month') return num * 30;
        if (unit === 'year') return num * 365;
      }
      return 9999;
    }
    function cadenceSort(a, b) { return cadenceWeight(a) - cadenceWeight(b); }
    // Backwards-compatible single-allocation getters (first matching).
    function alloc90(v) { var as = allocs90(v); return as.length ? as[0] : null; }
    function alloc30(v) { var as = allocs30(v); return as.length ? as[0] : null; }

    function formatMoney(cents) {
      if (cents == null) return '';
      var dollars = (cents / 100);
      var formatted = dollars.toFixed(2);
      // Use shop money format if it contains amount placeholders
      if (moneyFormat.indexOf('{{amount}}') !== -1) {
        var withCommas = formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return moneyFormat.replace('{{amount}}', withCommas);
      }
      return '$' + formatted;
    }

    // Quantity stepper
    var qtyInput = s.querySelector('input[name="quantity"]');
    if (qtyInput) {
      var down = s.querySelector('[data-mf-qty-down]');
      var up = s.querySelector('[data-mf-qty-up]');
      if (down) down.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (up) up.addEventListener('click', function() {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = v + 1;
      });
    }

    // Thumbnail swap
    var mainImg = s.querySelector('.mf-mp-main-image img');
    s.querySelectorAll('[data-mf-thumb]').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.image;
        s.querySelectorAll('[data-mf-thumb]').forEach(function(t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Variant data
    var variantBlob = s.querySelector('script[data-mf-variant-data]');
    var variants = [];
    if (variantBlob) {
      try { variants = JSON.parse(variantBlob.textContent || '[]'); } catch (e) { variants = []; }
    }

    var variantInput = s.querySelector('[data-mf-variant-id-input]');
    var sellingPlanInput = s.querySelector('input[name="selling_plan"]');
    var atcLabel = s.querySelector('[data-mf-atc-label]');
    var atcButton = s.querySelector('.mf-mp-atc');
    var card90 = s.querySelector('.mf-mp-plan-card--90day');
    var card30 = s.querySelector('.mf-mp-plan-card--30day');
    var cardOne = s.querySelector('.mf-mp-plan-card--onetime');
    var price90El = s.querySelector('[data-mf-plan-90-price]');
    var compare90El = s.querySelector('[data-mf-plan-90-compare]');
    var cadence90El = s.querySelector('[data-mf-plan-90-cadence]');
    var price30El = s.querySelector('[data-mf-plan-30-price]');
    var compare30El = s.querySelector('[data-mf-plan-30-compare]');
    var cadence30El = s.querySelector('[data-mf-plan-30-cadence]');
    var priceOneEl = s.querySelector('[data-mf-plan-onetime-price]');
    var compareOneEl = s.querySelector('[data-mf-plan-onetime-compare]');

    function pluralize(count, singular) {
      return count === 1 ? singular : singular + 's';
    }
    // Pull "every N <unit>" out of "Every 4 Weeks" / "Weekly · 4" etc. — returns {count, unit} or null.
    function parseIntervalFromName(name) {
      if (!name) return null;
      var m = name.match(/(\d+)\s*(day|week|month|year)/i);
      if (!m) return null;
      return { count: parseInt(m[1], 10), unit: m[2].toLowerCase() };
    }
    function getDeliveryInterval(alloc) {
      var n = parseInt(alloc.delivery_interval_count, 10);
      var u = alloc.delivery_interval;
      if (!isNaN(n) && n > 0 && u) return { count: n, unit: u };
      return parseIntervalFromName(alloc.selling_plan_name);
    }
    function getBillingInterval(alloc) {
      var n = parseInt(alloc.billing_interval_count, 10);
      var u = alloc.billing_interval;
      if (!isNaN(n) && n > 0 && u) return { count: n, unit: u };
      return null;
    }
    function formatCadence(alloc) {
      if (!alloc) return '';
      var d = getDeliveryInterval(alloc);
      var b = getBillingInterval(alloc);
      var parts = [];
      if (d) parts.push('Ships every ' + d.count + ' ' + pluralize(d.count, d.unit));
      if (b) {
        var sameAsDelivery = d && b.count === d.count && b.unit === d.unit;
        if (sameAsDelivery) parts.push('billed each delivery');
        else parts.push('billed every ' + b.count + ' ' + pluralize(b.count, b.unit));
      }
      if (!parts.length && alloc.selling_plan_name) return alloc.selling_plan_name;
      return parts.join(' · ');
    }
    var softCommit = s.querySelector('[data-mf-show-when="90day"]');
    var addonToggle = s.querySelector('[data-mf-addon-toggle]');

    function getCurrentVariant() {
      var selectedValues = {};
      s.querySelectorAll('[data-mf-variant-pill].is-selected').forEach(function(p) {
        selectedValues[p.dataset.optionPosition] = p.dataset.optionValue;
      });
      var positions = Object.keys(selectedValues);
      if (!positions.length) return variants[0] || null;
      return variants.find(function(v) {
        return positions.every(function(pos) {
          var idx = parseInt(pos, 10) - 1;
          return v.options && v.options[idx] === selectedValues[pos];
        });
      }) || null;
    }

    // Apply a single allocation's data to a plan card (price, compare, cadence, plan ID).
    function applyAllocation(card, alloc, priceEl, compareEl, cadenceEl, variantPrice) {
      if (!card || !alloc) return;
      card.dataset.mfPlanId = alloc.selling_plan_id;
      if (priceEl) priceEl.textContent = formatMoney(alloc.price);
      if (compareEl) {
        var cmp = alloc.compare_at_price || variantPrice;
        if (cmp && cmp > alloc.price) {
          compareEl.textContent = formatMoney(cmp);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (cadenceEl) {
        var c = formatCadence(alloc);
        if (c) cadenceEl.textContent = c;
      }
      // If this card is currently selected, also sync the hidden selling_plan input.
      if (card.classList.contains('is-selected') && sellingPlanInput) {
        sellingPlanInput.value = alloc.selling_plan_id || '';
      }
    }

    // Format a cadence pill's label: "Every 4 weeks", "Every 6 weeks", etc.
    function cadencePillLabel(alloc) {
      var d = getDeliveryInterval(alloc);
      if (d) return 'Every ' + d.count + ' ' + pluralize(d.count, d.unit);
      return alloc.selling_plan_name || 'Cadence';
    }

    // Render cadence pills into a card's picker container. Default-selects the first allocation.
    function renderCadencePicker(card, allocs, priceEl, compareEl, cadenceEl, variantPrice) {
      if (!card) return;
      var wrap = card.querySelector('[data-mf-cadence-card]');
      if (!wrap) return;
      var pillsContainer = wrap.querySelector('.mf-mp-cadence-pills');
      if (!pillsContainer) return;
      pillsContainer.innerHTML = '';
      // Hide picker entirely if 0 or 1 cadence option (no choice to offer).
      if (!allocs.length || allocs.length === 1) {
        wrap.hidden = true;
        return;
      }
      wrap.hidden = false;
      allocs.forEach(function(alloc, idx) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mf-mp-cadence-pill' + (idx === 0 ? ' is-selected' : '');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', idx === 0 ? 'true' : 'false');
        btn.dataset.mfCadenceId = alloc.selling_plan_id;
        btn.textContent = cadencePillLabel(alloc);
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          // Update active state on all pills in this picker.
          pillsContainer.querySelectorAll('.mf-mp-cadence-pill').forEach(function(p) {
            var on = p === btn;
            p.classList.toggle('is-selected', on);
            p.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          // Apply the chosen allocation to this card.
          applyAllocation(card, alloc, priceEl, compareEl, cadenceEl, variantPrice);
          // If this card isn't currently selected, select it as the active plan.
          var plan = card.dataset.mfPlan;
          if (plan && !card.classList.contains('is-selected')) {
            selectPlan(plan);
          }
        });
        pillsContainer.appendChild(btn);
      });
    }

    function updatePricesForVariant(v) {
      if (!v) return;
      // One-time card — always shows variant.price
      if (priceOneEl) priceOneEl.textContent = formatMoney(v.price);
      if (compareOneEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareOneEl.textContent = formatMoney(v.compare_at_price);
          compareOneEl.style.display = '';
        } else {
          compareOneEl.style.display = 'none';
        }
      }
      // 3-Pack card
      var as90 = allocs90(v);
      var a90 = as90[0] || null;
      if (card90) {
        if (a90) {
          card90.classList.remove('is-hidden');
          applyAllocation(card90, a90, price90El, compare90El, cadence90El, v.price);
          renderCadencePicker(card90, as90, price90El, compare90El, cadence90El, v.price);
        } else {
          card90.classList.add('is-hidden');
        }
      }
      // 1-Pack card
      var as30 = allocs30(v);
      // Strip allocations that are also in the 3-Pack list so they don't double up.
      if (a90) {
        as30 = as30.filter(function(a) {
          return !as90.some(function(b) { return b.selling_plan_id === a.selling_plan_id; });
        });
      }
      var a30 = as30[0] || null;
      if (card30) {
        if (a30) {
          card30.classList.remove('is-hidden');
          applyAllocation(card30, a30, price30El, compare30El, cadence30El, v.price);
          renderCadencePicker(card30, as30, price30El, compare30El, cadence30El, v.price);
        } else {
          card30.classList.add('is-hidden');
        }
      }
      // If currently-selected plan is hidden, fall back to one-time
      var selectedCard = s.querySelector('.mf-mp-plan-card.is-selected');
      if (selectedCard && selectedCard.classList.contains('is-hidden')) {
        selectPlan('onetime', { silent: false });
      }
      // Variant id on form
      if (variantInput) variantInput.value = v.id;
      // ATC availability
      if (atcButton) {
        if (!v.available) {
          atcButton.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Sold out';
        } else {
          atcButton.disabled = false;
        }
      }
    }

    function selectPlan(plan, opts) {
      opts = opts || {};
      var card = s.querySelector('.mf-mp-plan-card[data-mf-plan="' + plan + '"]');
      if (!card) return;
      if (card.classList.contains('is-hidden')) return;
      s.querySelectorAll('.mf-mp-plan-card').forEach(function(c) {
        c.classList.toggle('is-selected', c === card);
      });
      // Sync hidden selling_plan input (the card carries the resolved plan ID from updatePricesForVariant)
      if (sellingPlanInput) sellingPlanInput.value = card.dataset.mfPlanId || '';
      // ATC label
      if (atcLabel && atcButton && !atcButton.disabled) {
        atcLabel.textContent = atcLabels[plan] || atcLabels.onetime;
      }
      // Soft-commit policy visibility — only on the 90-day bundled tier
      if (softCommit) softCommit.classList.toggle('is-visible', plan === '90day');
      if (!opts.silent) {
        document.dispatchEvent(new CustomEvent('mf-plan-changed', { detail: { plan: plan, sectionId: s.id || null } }));
      }
    }

    // Plan card click handlers
    s.querySelectorAll('.mf-mp-plan-card').forEach(function(card) {
      card.addEventListener('click', function() {
        var plan = card.dataset.mfPlan;
        if (plan) selectPlan(plan);
      });
    });

    // Variant pill click handlers
    s.querySelectorAll('[data-mf-variant-pill]').forEach(function(pill) {
      pill.addEventListener('click', function() {
        var pos = pill.dataset.optionPosition;
        s.querySelectorAll('[data-mf-variant-pill][data-option-position="' + pos + '"]').forEach(function(p) {
          var on = p === pill;
          p.classList.toggle('is-selected', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var v = getCurrentVariant();
        updatePricesForVariant(v);
        // If currently-selected plan is no longer valid, reselect
        var selected = s.querySelector('.mf-mp-plan-card.is-selected');
        if (selected && selected.classList.contains('is-hidden')) {
          selectPlan('onetime', { silent: false });
        }
      });
    });

    // Listen for sticky-bar plan changes
    document.addEventListener('mf-plan-changed-from-sticky', function(e) {
      if (e.detail && e.detail.plan) selectPlan(e.detail.plan, { silent: true });
    });

    // One-time add-on: when checked, intercept ATC and add both the main item AND the addon
    // variant via /cart/add.js multi-item. Falls back to normal form submit if MFCart isn't available.
    var mainForm = s.querySelector('.mf-mp-form');
    if (mainForm && addonToggle) {
      mainForm.addEventListener('submit', function(e) {
        // Only intercept if One-time is selected AND addon is checked
        var selected = s.querySelector('.mf-mp-plan-card.is-selected');
        var plan = selected ? selected.dataset.mfPlan : null;
        if (plan !== 'onetime' || !addonToggle.checked) return; // normal submit
        var addonVariantId = parseInt(addonToggle.dataset.mfAddonVariant, 10);
        if (!addonVariantId) return; // normal submit
        if (!window.MFCart || typeof window.MFCart.addMultiple !== 'function') return; // no JS cart API; let form submit
        e.preventDefault();
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        var v = getCurrentVariant();
        if (!v) return;
        window.MFCart.addMultiple([
          { id: v.id, quantity: qty },
          { id: addonVariantId, quantity: 1 }
        ]);
      });
    }

    // Size calculator: trigger + result handler
    var calcTrigger = s.querySelector('[data-mf-open-calc]');
    if (calcTrigger) {
      calcTrigger.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('open-size-calculator'));
      });
    }
    var calcResult = s.querySelector('[data-mf-calc-result]');
    document.addEventListener('size-calculator-result', function (e) {
      var d = e.detail || {};
      // Render result text
      if (calcResult) {
        var months = d.recommended === '33' ? d.months33 : d.months64;
        var label = formatMonths(months);
        var rec = d.recommended === '33' ? '33 oz' : '64 oz';
        calcResult.innerHTML = '<strong>Recommended for your home: <em>' + rec + '</em></strong> · ' + label + ' · <a data-mf-recalc>recalculate</a>';
        calcResult.hidden = false;
        var recalc = calcResult.querySelector('[data-mf-recalc]');
        if (recalc) recalc.addEventListener('click', function () {
          document.dispatchEvent(new CustomEvent('open-size-calculator'));
        });
      }
      // Auto-select the recommended size variant on the size pill row
      var sizePills = s.querySelectorAll('[data-mf-variant-pill]');
      sizePills.forEach(function (p) {
        var v = (p.dataset.optionValue || '').replace(/\D/g, '');
        if (v && v === d.recommended) p.click();
      });
    });

    function formatMonths(m) {
      if (!m || m <= 0) return 'lasts a few weeks';
      if (m < 1) return 'lasts ~' + Math.max(1, Math.round(m * 4.33)) + ' weeks';
      if (m < 1.5) return 'lasts ~1 month';
      if (m < 11) return 'lasts ~' + Math.round(m) + ' months';
      if (m < 13) return 'lasts ~1 year';
      return 'lasts over a year';
    }

    // Initial price hydration + soft-commit visibility based on default selected plan
    var initialVariant = getCurrentVariant();
    if (initialVariant) updatePricesForVariant(initialVariant);
    var defaultPlan = s.dataset.mfDefaultPlan || 'onetime';
    if (softCommit) softCommit.classList.toggle('is-visible', defaultPlan === '90day');
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-pdp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  var bar = document.querySelector('.mf-pdp-sticky');
  if (!bar || bar.dataset.mfBound === '1') return;
  bar.dataset.mfBound = '1';

  var toggle = bar.querySelector('[data-mf-sticky-toggle]');
  var btns = bar.querySelectorAll('[data-mf-plan]');
  var ctaBtn = bar.querySelector('[data-mf-sticky-cta]');
  var ctaLabel = bar.querySelector('[data-mf-sticky-label]');

  // Read CTA labels from the main product section's data attributes
  var main = document.querySelector('.mf-main-product');
  var ctaLabels = {
    '90day':   (main && main.dataset.mfAtcLabel90) || 'Subscribe & Get Kit FREE',
    '30day':   (main && main.dataset.mfAtcLabel30) || 'Subscribe — Monthly',
    'onetime': (main && main.dataset.mfAtcLabelOne) || 'Add to cart'
  };

  function setActive(plan, opts) {
    opts = opts || {};
    // If sticky doesn't have a button for the requested plan (e.g. subscriptions not available),
    // fall back to onetime so we never end up with nothing active.
    var hasBtn = false;
    btns.forEach(function(b) { if (b.dataset.mfPlan === plan) hasBtn = true; });
    if (!hasBtn) plan = 'onetime';

    btns.forEach(function(b) {
      var match = b.dataset.mfPlan === plan;
      b.classList.toggle('is-active', match);
      b.setAttribute('aria-checked', match ? 'true' : 'false');
    });
    if (ctaLabel) ctaLabel.textContent = ctaLabels[plan] || ctaLabels.onetime;
    if (!opts.silent) {
      document.dispatchEvent(new CustomEvent('mf-plan-changed-from-sticky', { detail: { plan: plan } }));
    }
  }

  // User clicks sticky toggle
  if (toggle) {
    toggle.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mf-plan]');
      if (!btn) return;
      setActive(btn.dataset.mfPlan);
    });
  }

  // Listen for plan changes from main product cards
  document.addEventListener('mf-plan-changed', function(e) {
    if (e.detail && e.detail.plan) setActive(e.detail.plan, { silent: true });
  });

  // Sticky CTA → triggers main ATC button submit
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function() {
      var atc = document.querySelector('.mf-mp-atc');
      if (atc && !atc.disabled) atc.click();
    });
  }

  // Show after scrolling past the hero
  var threshold = 400;
  function onScroll() {
    if (window.scrollY > threshold) bar.classList.add('is-visible');
    else bar.classList.remove('is-visible');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Initialize
  var initial = bar.dataset.mfDefaultPlan || '90day';
  setActive(initial, { silent: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-problem"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('[data-mf-problem]');
  if (!section || section.dataset.mfBound === '1') return;
  section.dataset.mfBound = '1';

  var nodes = section.querySelectorAll('[data-mf-count]');
  if (!nodes.length) return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseTarget(raw) {
    // Strip commas, currency, spaces. Keep digits + a single decimal point.
    var cleaned = String(raw).replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    if (!cleaned) return null;
    var n = parseFloat(cleaned[0]);
    if (!isFinite(n)) return null;
    var hasCommas = /\d{1,3}(,\d{3})+/.test(String(raw));
    var hasDecimal = /\.\d/.test(String(raw));
    var prefixMatch = String(raw).match(/^[^\d-]+/);
    var suffixMatch = String(raw).match(/[^\d.]+$/);
    return {
      target: n,
      prefix: prefixMatch ? prefixMatch[0] : '',
      suffix: suffixMatch ? suffixMatch[0] : '',
      hasCommas: hasCommas,
      hasDecimal: hasDecimal,
      decimals: hasDecimal ? (String(raw).split('.')[1] || '').replace(/[^\d]/g, '').length : 0
    };
  }

  function format(n, info) {
    var rounded = info.hasDecimal ? n.toFixed(info.decimals) : Math.round(n).toString();
    if (info.hasCommas && !info.hasDecimal) {
      rounded = Math.round(n).toLocaleString('en-US');
    } else if (info.hasCommas && info.hasDecimal) {
      var parts = rounded.split('.');
      parts[0] = parseInt(parts[0], 10).toLocaleString('en-US');
      rounded = parts.join('.');
    }
    return info.prefix + rounded + info.suffix;
  }

  function animateNode(node) {
    var raw = node.dataset.mfCount;
    var info = parseTarget(raw);
    if (!info) return;
    if (prefersReduced) {
      node.textContent = format(info.target, info);
      return;
    }
    var duration = Math.max(900, Math.min(1600, 600 + Math.log10(Math.max(info.target, 10)) * 250));
    var start = null;
    function ease(t) { return 1 - Math.pow(1 - t, 4); } // easeOutQuart
    function step(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      var t = Math.min(1, elapsed / duration);
      var v = info.target * ease(t);
      node.textContent = format(v, info);
      if (t < 1) requestAnimationFrame(step);
      else node.textContent = format(info.target, info);
    }
    // Start at zero
    node.textContent = format(0, info);
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          animateNode(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    nodes.forEach(function(n) { io.observe(n); });
  } else {
    // No IO support — just render the final value
    nodes.forEach(function(n) {
      var info = parseTarget(n.dataset.mfCount);
      if (info) n.textContent = format(info.target, info);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-rainforest-cost"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('.mf-rfc .mf-rfc-reveal');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { observer.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
